import { useState } from 'react';
import * as Yup from 'yup';
import toast from 'react-hot-toast';

import { useLazyGetFilterOptionsQuery } from '../../../../../../services/contacts';

export const useTagsFilter = ({ sharedList, orderBy, setFilters }) => {
  const [getFilterOptions] = useLazyGetFilterOptionsQuery();
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const formSchema = Yup.object().shape({
    tags: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSearchChange = async (currentValue) => {
    try {
      const data = await getFilterOptions({
        facet: 'tags',
        query: currentValue,
        sharedList,
        orderBy,
      }).unwrap();

      return data;
    } catch (error) {
      toast('Failed to load tags', {
        icon: 'danger',
        id: 'failed-to-load-tags',
      });
      return [];
    }
  };

  const onSubmit = ({ tags }) => {
    setFilters({ tags });
  };

  const onMenuOpen = () => {
    setIsLoading(true);
    onSearchChange('')
      .then((data) => {
        setDefaultOptions(data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    formSchema,
    defaultOptions,
    isLoading,
    onMenuOpen,
    onSearchChange,
    onSubmit,
  };
};
